import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import "@/App.css";
import PublicForm from "@/pages/PublicForm";
import Admin from "@/pages/Admin";
import StaffOffer from "@/pages/StaffOffer";
import StaffLogin from "@/pages/StaffLogin";

function App() {
  return (
    <div className="App">
      <Toaster position="bottom-right" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicForm />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/staff/login" element={<StaffLogin />} />
          <Route path="/staff" element={<StaffOffer />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
